/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { tokens } from '@neo4j-ndl/base';
import { Box, Flex } from '@neo4j-ndl/react';

const Tiles = `
  linear-gradient(
    45deg,
    var(--theme-color-neutral-bg-strong) 25%,
    transparent 25%
  ),
  linear-gradient(
    135deg,
    var(--theme-color-neutral-bg-strong) 25%,
    transparent 25%
  ),
  linear-gradient(
    45deg,
    transparent 75%,
    var(--theme-color-neutral-bg-strong) 75%
  ),
  linear-gradient(
    135deg,
    transparent 75%,
    var(--theme-color-neutral-bg-strong) 75%
  )
`;

const TiledTransparentBackground: React.CSSProperties = {
  backgroundColor: 'white',
  backgroundImage: Tiles,
  backgroundPosition: '0px 0px, 10px 0px, 10px -10px, 0px 10px',
  backgroundSize: '20px 20px',
  border: '1px solid var(--theme-color-neutral-border-weak)',
};

const component = () => (
  <Flex
    style={{
      ...TiledTransparentBackground,
      borderRadius: tokens.borderRadius['xl'],
      padding: tokens.space['12'],
    }}
  >
    {Array.from({ length: 3 }).map((_unused, index) => (
      <Box
        key={`box-${index}`}
        borderRadius="xl"
        style={{ height: '80px', minWidth: '240px' }}
        className="n-bg-primary-bg-weak n-border n-border-primary-border-strong"
      ></Box>
    ))}
  </Flex>
);

export default component;
